
import React from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';

export  const ProgressSpinnerDemo = () => {
    return (
        <ProgressSpinner className="p-progress-spinner-color" strokeWidth= "3"  animationDuration = "4s" style={{width: '50px', height: '50px'}}/>
    );
}